"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseChainId = void 0;
function parseChainId(chainId) {
    const matches = chainId.match('^([a-z]{1,})_{1}([1-9][0-9]*)-{1}([1-9][0-9]*)$');
    if (!matches ||
        matches.length !== 4 ||
        matches[1] === '' ||
        Number.isNaN(Number(matches[2]))) {
        throw new Error(`Invalid chainId received: ${chainId}`);
    }
    return Number(matches[2]);
}
exports.parseChainId = parseChainId;
//# sourceMappingURL=utils.js.map